/** @format */
import isPropValid from '@emotion/is-prop-valid';

/**
 * Returns a validator function, taking into account an optional list of
 * disallowed props.
 */
export function propValidator(
    disallowedProps: string[] = []
): (prop: string | number | symbol) => boolean {
    return function (prop: string | number | symbol) {
        return (
            isPropValid(prop.toString()) &&
            !disallowedProps.includes(prop.toString())
        );
    };
}
